import AutomatedCatalogCarouselCardDesktop from '@/components/FeaturedCatalogCarousel/components/AutomatedCatalogCarouselCard/components/DesktopCard/AutomatedCatalogCarouselCardDesktop';
import AutomatedCatalogCarouselCardMobile from '@/components/FeaturedCatalogCarousel/components/AutomatedCatalogCarouselCard/components/MobileCard/AutomatedCatalogCarouselCardMobile';
import { useIsMobileLayout } from '@/hooks/useIsMobileLayout';

type Props = {
    cardWidth?: number;
    catalogId: number;
    shouldUseHomePageRedesign?: boolean;
    width: number;
};

const AutomatedCatalogCarouselCard = ({ cardWidth, catalogId, shouldUseHomePageRedesign = false, width }: Props) => {
    const isMobile = useIsMobileLayout();

    if (isMobile) {
        return (
            <AutomatedCatalogCarouselCardMobile
                catalogId={catalogId}
                shouldUseHomePageRedesign={shouldUseHomePageRedesign}
                width={width}
            />
        );
    }

    return (
        <AutomatedCatalogCarouselCardDesktop
            cardWidth={cardWidth}
            catalogId={catalogId}
        />
    );
};

export default AutomatedCatalogCarouselCard;
